/* eslint-disable import/no-cycle */
import Parent from '../views/Parent.vue';

// import view RBAC
import Permission from '../views/rbac/Permission.vue';
import UserRbac from '../views/rbac/User.vue';
import Role from '../views/rbac/Role.vue';
import RoleDetail from '../views/rbac/RoleDetail.vue';
import Routes from '../views/rbac/Route.vue';
import Rule from '../views/rbac/Rule.vue';
import Mapping from '../views/rbac/Mapping.vue';
import MappingCabang from '../views/rbac/MappingCabang.vue';
import MappingWilayahDetail from '../views/rbac/MappingWilayahDetail.vue';
import MappingCabangDetail from '../views/rbac/MappingCabangDetail.vue';

import { setBreadcrumb } from './index';

const rbacRoute = {
  path: '/rbac',
  meta: {
    title: 'BNI QRIS - RBAC',
    appBarTitle: 'RBAC',
  },
  component: Parent,
  children: [
    {
      path: '/rbac-user',
      name: 'UserRbac',
      meta: {
        title: 'BNI QRIS - User RBAC',
        appBarTitle: 'User RBAC',
      },
      component: UserRbac,
    },
    {
      path: '/rbac-permission',
      name: 'Permission',
      meta: {
        title: 'BNI QRIS - Permission',
        appBarTitle: 'Permission',
      },
      component: Permission,
    },
    {
      path: '/rbac-role',
      name: 'Role',
      meta: {
        title: 'BNI QRIS - Role',
        appBarTitle: 'Role',
        breadcrumbs: () => [
          setBreadcrumb('user management', '/rbac-role', true),
          setBreadcrumb('user role', '/rbac-role'),
        ],
      },
      component: Role,
    },
    {
      path: '/rbac-role/:id/view',
      meta: {
        title: 'BNI QRIS - View Detail Role',
        appBarTitle: 'View Detail Role',
        breadcrumbs: (params) => {
          const { id } = params;
          return [
            setBreadcrumb('user management', '/rbac-role', true),
            setBreadcrumb('user role', '/rbac-role'),
            setBreadcrumb(
              id.replaceAll('-', ' '),
              `/rbac-role/${id}/view`,
              true
            ),
          ];
        },
      },
      component: RoleDetail,
      name: 'RoleDetail',
    },
    {
      path: '/rbac-route',
      name: 'Route',
      meta: {
        title: 'BNI QRIS - Route',
        appBarTitle: 'Route',
      },
      component: Routes,
    },
    {
      path: '/rbac-rule',
      name: 'Rule',
      meta: {
        title: 'BNI QRIS - Rule',
        appBarTitle: 'Rule',
      },
      component: Rule,
    },
    {
      path: '/rbac-mapping-wilayah',
      name: 'Mapping',
      meta: {
        title: 'BNI QRIS - Mapping Wilayah',
        appBarTitle: 'Mapping Wilayah',
        breadcrumbs: () => [
          setBreadcrumb('user management', '/rbac-mapping-wilayah', true),
          setBreadcrumb('mapping wilayah', '/rbac-mapping-wilayah'),
        ],
      },
      component: Mapping,
    },
    {
      path: '/rbac-mapping-wilayah/:id/view',
      meta: {
        title: 'BNI QRIS - View Detail Mapping Wilayah',
        appBarTitle: 'View Detail Mapping Wilayah',
        breadcrumbs: (params) => {
          const { id } = params;
          return [
            setBreadcrumb('user management', '/rbac-mapping-wilayah', true),
            setBreadcrumb('mapping wilayah', '/rbac-mapping-wilayah'),
            setBreadcrumb(
              id.replaceAll('-', ' '),
              `/rbac-mapping-wilayah/${id}/view`,
              true
            ),
          ];
        },
      },
      component: MappingWilayahDetail,
      name: 'MappingWilayahDetail',
    },

    {
      path: '/rbac-mapping-cabang',
      name: 'Mapping Cabang',
      meta: {
        title: 'BNI QRIS - Mapping Cabang',
        appBarTitle: 'Mapping Cabang',
        breadcrumbs: () => [
          setBreadcrumb('user management', '/rbac-mapping-cabang', true),
          setBreadcrumb('mapping cabang', '/rbac-mapping-cabang'),
        ],
      },
      component: MappingCabang,
    },

    {
      path: '/rbac-mapping-cabang/:id/view',
      meta: {
        title: 'BNI QRIS - View Detail Mapping Cabang',
        appBarTitle: 'View Detail Mapping Cabang',
        breadcrumbs: (params) => {
          const { id } = params;
          return [
            setBreadcrumb('user management', '/rbac-mapping-cabang', true),
            setBreadcrumb('mapping cabang', '/rbac-mapping-cabang'),
            setBreadcrumb(
              id.replaceAll('-', ' '),
              `/rbac-mapping-cabang/${id}/view`,
              true
            ),
          ];
        },
      },
      component: MappingCabangDetail,
      name: 'MappingCabangDetail',
    },
  ],
};

export default rbacRoute;
